import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal, selectActiveModalData } from 'features/modal/modalSlice';
import { Trans, useTranslation } from 'react-i18next';
import { bulkMuteRemoteAudio } from 'features/streaming/actions';
import { usePermissions } from 'features/permissions/usePermissions';
import { useEffect } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { PermissionTypes } from 'features/permissions/types';

const BulkMuteRemoteAudioConfirmation = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const modalData = useAppSelector(selectActiveModalData);
  const role = modalData.role as string | undefined;
  const displayRoleName = modalData.displayRoleName as string | undefined;

  const { hasPermissions } = usePermissions();

  const canMute = hasPermissions(PermissionTypes.remoteMuting, {
    targetRole: role ?? { coverage: 'all' },
  });

  useEffect(() => {
    if (!canMute) {
      dispatch(closeModal('bulkMuteRemoteAudioConfirmation'));
    }
  }, [canMute, dispatch]);

  const handleCancel = () => {
    dispatch(closeModal('bulkMuteRemoteAudioConfirmation'));
  };

  const handleOk = () => {
    dispatch(bulkMuteRemoteAudio(role ? { roles: [role] } : undefined));
    dispatch(closeModal('bulkMuteRemoteAudioConfirmation'));
  };

  const copy = role
    ? {
        title: t('bulk_mute_remote_audio_role_confirm.title'),
        description: (
          <Trans
            i18nKey="modals:bulk_mute_remote_audio_role_confirm.description"
            t={t}
            values={{ role: displayRoleName }}
            components={{ bold: <strong /> }}
          />
        ),
        cancelText: t('bulk_mute_remote_audio_role_confirm.btn_cancel_label'),
        okText: t('bulk_mute_remote_audio_role_confirm.btn_ok_label'),
      }
    : {
        title: t('bulk_mute_remote_audio_confirm.title'),
        description: t('bulk_mute_remote_audio_confirm.description'),
        cancelText: t('bulk_mute_remote_audio_confirm.btn_cancel_label'),
        okText: t('bulk_mute_remote_audio_confirm.btn_ok_label'),
      };

  return (
    <ConfirmationDialog
      open
      {...copy}
      onOk={handleOk}
      onCancel={handleCancel}
      hideCloseButton
      preventClose
    />
  );
};

export default BulkMuteRemoteAudioConfirmation;
